import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box
} from "@mui/material";
import { StyledTextField } from "../../../../Components/Common/StyledTextField";
import { useTranslation } from "react-i18next";
import { useThemeContext } from "../../../../Context/ThemeContext";
import { DARKCOLORS, LIGHTCOLORS } from "../../../../Utils/constants";
import CloseIcon from "@mui/icons-material/Close";

const initialSpare = {
  name: "",
  serialNo: "",
  quantity: '',
  price: ''
};

const initialErrors = {
  name: "",
  serialNo: "",
  quantity: "",
  price: ""
};

const AddSparePartModal = ({ open, onClose, onSave }) => {
  const { t } = useTranslation();
  const { mode } = useThemeContext();

  const backgroundCard = mode === "dark" ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;
  const btnColor = mode === "dark" ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;
  const inputBoxColor = mode === "dark" ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;

  const [spare, setSpare] = useState(initialSpare);
  const [errors, setErrors] = useState(initialErrors);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSpare((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" })); // clear error on change
  };

  const validate = () => {
    const newErrors = { ...initialErrors };
    let valid = true;

    if (!spare.name.trim()) {
      newErrors.name = t("serviceRequest.partNameRequired");
      valid = false;
    }

    if (!spare.serialNo.trim()) {
      newErrors.serialNo = t("serviceRequest.serialNumberRequired");
      valid = false;
    }

    if (!spare.quantity || isNaN(spare.quantity) || Number(spare.quantity) < 1) {
      newErrors.quantity = t("serviceRequest.quantityMinimum");
      valid = false;
    }

    if (!spare.price || isNaN(spare.price) || Number(spare.price) < 1) {
      newErrors.price = t("serviceRequest.priceMinimum");
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSave = () => {
    if (!validate()) return;

    onSave({
      ...spare,
      quantity: Number(spare.quantity),
      price: Number(spare.price)
    });

    setSpare(initialSpare);
    setErrors(initialErrors);
  };

  const handleClose = () => {
    setSpare(initialSpare);
    setErrors(initialErrors);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ background: backgroundCard }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2 className="machine-name-text" style={{ marginBottom: "0px" }}>{t("serviceRequest.addSpare")}</h2>
          <IconButton sx={{ p: 0 }} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ gap: 2, display: 'flex', flexDirection: 'column' , background: backgroundCard }}>
        <StyledTextField
          label={t("serviceRequest.partName")}
          name="name"
          value={spare.name}
          onChange={handleChange}
          required
          error={errors.name}
          inputBoxColor={inputBoxColor}
        />
        <StyledTextField
          label={t("serviceRequest.serialNo")}
          name="serialNo"
          value={spare.serialNo}
          onChange={handleChange}
          required
          error={errors.serialNo}
          inputBoxColor={inputBoxColor}
        />
        <StyledTextField
          label={t("serviceRequest.quantity")}
          name="quantity"
          numberType
          value={spare.quantity}
          onChange={handleChange}
          required
          error={errors.quantity}
          inputBoxColor={inputBoxColor}
        />
        <StyledTextField
          label={t("serviceRequest.price")}
          name="price"
          numberType
          value={spare.price}
          onChange={handleChange}
          required
          error={errors.price}
          inputBoxColor={inputBoxColor}
        />
      </DialogContent>
      <DialogActions sx={{ py: 2, pr: 3,background: backgroundCard }}>
        <button type="button" style={{ color: btnColor, borderColor: btnColor }} className='cancel-btn' onClick={handleClose}>
          {t('membershipCards.cancel')}
        </button>
        <button type="button" onClick={handleSave} style={{ background: btnColor }} className='save-btn'>
          {t('membershipCards.save')}
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default AddSparePartModal;
